import Vue from 'vue'
import VueYoutube from 'vue-youtube'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueMq from 'vue-mq'
import VueGtag from "vue-gtag";

import 'swiper/css/swiper.css'

Vue.use(VueGtag, {
    config: { 
        id: "UA-4886955-1",
        params: {
            send_page_view: false
        }
    }
});

Vue.use(VueYoutube)
Vue.use(VueAwesomeSwiper)
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: Infinity
  },
  defaultBreakpoint: 'sm' // customize this for SSR
})

Vue.mixin(require('./mixins/asset.js'));

Vue.component('youtube-player', require('./components/motor-show/YoutubePlayer.vue').default)
Vue.component('model-carousel', require('./components/motor-show/ModelCarousel.vue').default)
Vue.component('model-popup', require('./components/motor-show/ModelPopup.vue').default)
Vue.component('promotion-carousel', require('./components/motor-show/PromotionCarousel.vue').default)
Vue.component('Pano', require('./components/motor-show/Pano.vue').default)
Vue.component('click-and-drag', require('./components/motor-show/ClickAndDrag.vue').default)
Vue.component('heading-special', require('./components/motor-show/HeadingSpecial.vue').default)

const app = new Vue({
    el: '#motor-show',

    data() {
        return {
            model: null,
            popupOpen: false,
        }
    },

    computed: {
        videoSource() {
            let source
            
            if (this.$mq === 'xs' || this.$mq === 'sm') source = window.videoMobile
            else source = window.videoDesktop

            return source
        }
    },

    methods: {
        openPopup(model) {
            this.model = model
            this.popupOpen = true
        }
    },
})



// WEBPACK FOOTER //
// ./resources/js/motor-show.js